(function () {
	const initCollapsibleContent = () => {
		jQuery(".collapsible-content__toggle").unbind("click").on("click", function () {
			const parent = jQuery(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent.addClass("active");
				jQuery(this)
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				jQuery(this).next().stop().slideDown(300);
			} else {
				parent.removeClass("active");
				jQuery(this).next().stop().slideUp(300);
			}
		});

		jQuery(".collapsible-content__item").mouseenter(function (event) {
			jQuery(this).removeClass("collapsible-content__item--opacity");
			jQuery(this)
				.siblings()
				.addClass("collapsible-content__item--opacity");
			jQuery(this).mouseleave(() => {
				jQuery(this)
					.siblings()
					.removeClass("collapsible-content__item--opacity");
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
